import script from "./LLMPortrait.vue?vue&type=script&setup=true&lang=ts"
export * from "./LLMPortrait.vue?vue&type=script&setup=true&lang=ts"

import "./LLMPortrait.vue?vue&type=style&index=0&id=caf1cee8&scoped=true&lang=scss"

import exportComponent from "/var/www/fgc-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-caf1cee8"]])

export default __exports__